import { Component, Vue } from 'vue-property-decorator'
import FormDocumentCCSS from '@/components/CCSSForm/Document/Document.vue'
import http from '@/services/http'
import CCSSDocument from '@/Models/CCSSDocument'
import Search from '@/components/Search/Search.vue'
import Crm from '@/Models/Crm'
import ModalDelete from '@/components/ModalDelete/ModalDelete.vue'
import * as Helpers from '@/helpers'
import menuModule from '@/store/menu'
import Header from '@/components/Header/Header.vue'
import router from '@/router'
import Animation from '@/components/Animation/index.vue'
@Component({
  components: {
    FormDocumentCCSS,
    Search,
    ModalDelete,
    Header,
    Animation,
  },
})
export default class ViewDocumentCCSS extends Vue {
  showList = true
  data: Array<CCSSDocument> = []
  objCCSSDocument: CCSSDocument = new CCSSDocument()
  action = 'add'
  member: Crm = new Crm()
  loading = false
  delete_modal_active = false
  baseUrl = ''
  currentPage = 1
  header: Array<any> = [
    {
      field: 'date_read',
      label: 'Fecha',
    },
    {
      field: 'comment',
      label: 'Comentario',
    },
    {
      field: 'file',
      label: 'Doc',
    },
  ]
  mounted() {
    this.getCCSSDocument()
    this.baseUrl = process.env.VUE_APP_API_URL
    ;(this.$refs.header as any).isViewPrincipal = false
  }

  async getCCSSDocument() {
    this.loading = true
    try {
      const id = menuModule.id_param
      if (id == null) throw router.push({ name: 'CCSS' }).catch(console.log)
      const res = await http.get(`/api/ccss/arcr_ccss_document/${id}/`)
      if (!res.data) throw new Error(res.data)

      if (res.data.documents != 'Este Seguro no tiene documentos') {
        console.log(res.data.documents)
        this.data = res.data.documents.map((obj: any) => ({
          ...obj,
          ccss_id: this.$route.query.id,
          date_read: obj.date_presented,
          file: obj.file != null ? obj.file.slice(1) : obj.file,
          date_presented: Helpers.dateParse(obj.date_presented),
          upload:
            obj.file != null
              ? new File(
                  ['foo'],
                  obj.file.substring(obj.file.lastIndexOf('/') + 1),
                )
              : null,
        }))
      }
      this.member = res.data.member
    } catch (error) {
      console.error(error)
      this.$buefy.toast.open({
        message: `Ups!, ha ocurrido un error`,
        type: 'is-danger',
      })
    }
    this.loading = false
  }

  editObj(props: any) {
    this.objCCSSDocument = props
    this.showList = false
    this.action = 'edit'
  }
  async deleteObj() {
    try {
      await http.delete(
        `/api/ccss/arcr_ccss_document/${this.objCCSSDocument.id}/`,
      )
      this.data = this.data.filter(
        (a: CCSSDocument) => a.id !== this.objCCSSDocument.id,
      )
      this.delete_modal_active = false
      this.getCCSSDocument()
    } catch (error) {
      console.log(error)
      //toast.error("An error has occurred please try again.")
    }
  }
  deleteConfirm(props: any) {
    this.delete_modal_active = true
    this.objCCSSDocument = props
  }
  closeModal() {
    this.objCCSSDocument = new CCSSDocument()
    this.delete_modal_active = false
  }
  openForm() {
    this.showList = false
  }
  async cleanForm() {
    ;(this.$refs.header as any).showList = true
    //(this.$refs['headerForm'] as any)['showList'] = true
    this.objCCSSDocument = new CCSSDocument()
    this.showList = true
    this.action = 'add'
    await this.getCCSSDocument()
  }
  isData(data: any) {
    this.data = data
  }
  filterItems(items: any) {
    this.data = items
  }
}
